import React, {useState} from 'react';
import "./Header.css";
import { Link } from 'react-router-dom'; 

const Header = () => {
      // fixed Header
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header")
    header.classList.toggle("active", window.scrollY > 100)
  })
  // Toogle Menu
  const [Mobile, setMobile] = useState(false);
  return (
    <>
      <header className='header'>
        <div className='container headerFlex'>
          <div className='logo'>
            <img src="./images/Logo.jpg" alt='Logo' className="navLogo" />
          </div>

          <div className='navlink'>
            <ul className={Mobile ? "nav-links-mobile" : "link f-Flex displayFlex uppercase"} onClick={() => setMobile(false)}>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li>
                <Link to='/about'>About</Link>
              </li>
              <li>
              <Link to='/classes'>Classes</Link>
              </li>
              <li>
              <Link to='/freeResources'>Free Resources</Link>
              </li>
              <li>
                <Link to='/blog'>blog</Link>
              </li>
              <li>
                <Link to='/contact'>contact</Link>
              </li>
            </ul>

            <button className='toggle' onClick={() => setMobile(!Mobile)}>
            {Mobile ? <i className='fas fa-times close home-btn'></i> : <i className='fas fa-bars open'></i>}
            </button>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header